export const url = '/tours';
export const Provider = 'Tours';
export const TABLE_NAME = 'tours';

// export const dbModel = 'Tours';
